import { render, staticRenderFns } from "./DeleteAll.vue?vue&type=template&id=fb4fccdc&scoped=true"
import script from "./DeleteAll.vue?vue&type=script&lang=js"
export * from "./DeleteAll.vue?vue&type=script&lang=js"
import style0 from "./DeleteAll.vue?vue&type=style&index=0&id=fb4fccdc&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4fccdc",
  null
  
)

export default component.exports